









import { computed, defineComponent } from "@vue/composition-api";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { Subscription } from "@teacherskaya/api-provider/dist/api/SubscriptionProvider";
import useRecurring from "@/hooks/useRecurring";
import { $t } from "@/lib/helpers/i18nHelper";
import ProfileRecurringView from "../ProfileRecurringView";

export default defineComponent({
  name: "BlockSubscriptions",
  components: { ProfileRecurringView },
  props: {
    user: { type: Object as () => User, required: true },
  },
  setup(props) {
    const { subscriptions, onCancel, getRecurrings, getRecurringData } = useRecurring();
    const texts = computed(() => {
      return {
        title: $t("Subscriptions"),
        noSubs: $t("No {0} yet", [$t("subscriptions")]),
        allSubs: $t("All {0}", [$t("subscriptions")]),
      };
    });

    const onCancelRebill = (subscription: Subscription) => {
      onCancel(subscription);
    };
    const onRemoveAccess = (subscription: Subscription) => {
      onCancel(subscription, true);
    };

    getRecurringData(getRecurrings, props.user.id, 0, 3);

    return {
      texts,
      subscriptions,
      onCancelRebill,
      onRemoveAccess,
    };
  },
});
